var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Modal } from 'common/core/ui/dialogs/modal.service';
import { CrupdateFolderDialogComponent } from '../../folders/components/crupdate-folder-dialog/crupdate-folder-dialog.component';
import { Select, Store } from '@ngxs/store';
import { UploadFiles } from '../../state/actions/commands';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
var SidebarActionButtonsComponent = /** @class */ (function () {
    function SidebarActionButtonsComponent(dialog, store, uploadInputConfig) {
        this.dialog = dialog;
        this.store = store;
        this.uploadInputConfig = uploadInputConfig;
    }
    SidebarActionButtonsComponent.prototype.openNewFolderDialog = function () {
        this.dialog.open(CrupdateFolderDialogComponent);
    };
    SidebarActionButtonsComponent.prototype.openUploadsPanel = function (files) {
        this.store.dispatch(new UploadFiles(files));
    };
    __decorate([
        Select(DriveState.canUpload),
        __metadata("design:type", Observable)
    ], SidebarActionButtonsComponent.prototype, "canUpload$", void 0);
    return SidebarActionButtonsComponent;
}());
export { SidebarActionButtonsComponent };
